var _rect, _path, _path2, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToContestIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    transform: "matrix(-1 0 0 1 28 0)",
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.625 13.375H7.125C6.95924 13.375 6.80027 13.4408 6.68306 13.5581C6.56585 13.6753 6.5 13.8342 6.5 14C6.5 14.1658 6.56585 14.3247 6.68306 14.4419C6.80027 14.5592 6.95924 14.625 7.125 14.625H19.625C19.7908 14.625 19.9497 14.5592 20.0669 14.4419C20.1842 14.3247 20.25 14.1658 20.25 14C20.25 13.8342 20.1842 13.6753 20.0669 13.5581C19.9497 13.4408 19.7908 13.375 19.625 13.375Z",
    fill: "#F6F6F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3661 14L14.1824 19.1825C14.065 19.2999 13.9991 19.459 13.9991 19.625C13.9991 19.791 14.065 19.9501 14.1824 20.0675C14.2997 20.1849 14.4589 20.2508 14.6249 20.2508C14.7908 20.2508 14.95 20.1849 15.0674 20.0675L20.6924 14.4425C20.7506 14.3844 20.7967 14.3155 20.8282 14.2395C20.8598 14.1636 20.876 14.0822 20.876 14C20.876 13.9178 20.8598 13.8364 20.8282 13.7605C20.7967 13.6845 20.7506 13.6156 20.6924 13.5575L15.0674 7.9325C14.95 7.81514 14.7908 7.74921 14.6249 7.74921C14.4589 7.74921 14.2997 7.81514 14.1824 7.9325C14.065 8.04985 13.9991 8.20903 13.9991 8.375C13.9991 8.54097 14.065 8.70014 14.1824 8.8175L19.3661 14Z",
    fill: "#F6F6F6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    transform: "matrix(-1 0 0 1 27 0)",
    stroke: "white",
    strokeOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToContestIcon);
export default __webpack_public_path__ + "static/media/toContestIcon.8074eab709506b70e08ab2663813a492.svg";
export { ForwardRef as ReactComponent };